import { render, staticRenderFns } from "./CompanyUsageSelect.vue?vue&type=template&id=402e2c1d&scoped=true&"
import script from "./CompanyUsageSelect.vue?vue&type=script&lang=ts&"
export * from "./CompanyUsageSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e2c1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
